<template>
  <el-dialog :visible.sync="domVisible" customClass="uploadHeadBox" :lock-scroll="false" :before-close="handleClose">
    <div style="display:flex;" v-loading="disabled">
      <div class="cropper" style="text-align:center">
        <vueCropper ref="cropper" style="background-image: none;background: #000;" :img="option.img" :outputSize="option.outputSize" :outputType="option.outputType" :info="option.info" :centerBox="option.centerBox" :canScale="option.canScale" :autoCrop="option.autoCrop" :autoCropWidth="option.autoCropWidth" @realTime="realTime" :autoCropHeight="option.autoCropHeight" :fixed="option.fixed" :fixedBox="option.fixedBox" :fixedNumber="option.fixedNumber">
        </vueCropper>
      </div>
      <div class="line"></div>
      <div class="preview-box">
        <!-- <div>{{previews}}</div> -->
        <div class="preview" :style="previewsStyle">
          <div :style="previews.div">
            <img :src="previews.url" :style="previews.img" />
          </div>
        </div>
        <div class="preview_img">{{$t('base.preview')}}</div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button :disabled="disabled" @click="handleClose">{{$t('base.cancel')}}</el-button>
      <el-button :disabled="disabled" type="primary" @click="finish">{{$t('base.confirm')}}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { VueCropper } from 'vue-cropper'
export default {
  name: 'uploaddialog',
  data() {
    return {
      disabled:false,
      previews: {},//预览data
      previewsStyle: "",//预览外层样式
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 100, // 默认生成截图框宽度
        autoCropHeight: 100, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        canMove: true,
      },
    }
  },
  props: {
    imgbase: '',
    domVisible: Boolean,
  },
  created() {
    //base64格式图片
    this.option.img = this.imgbase
  },
  components: {
    VueCropper,
  },
  methods: {
    //关闭弹框
    handleClose() {
      this.$emit('DialogColse', 'upload', false)
    },
    //截图
    finish() {
      console.log(this.$refs.cropper, 'this.$refs.cropper')
      this.disabled=true;
      this.$refs.cropper.getCropBlob((data) => {
        //把获取到的blob格式文件转换成file格式文件
        let newfile = new File([data], 'jpg', { type: 'jpg/jpeg', lastModified: Date.now() })
        // console.log('fileName', newfile)
        this.$emit("uploadImg", newfile)
      })
    },
    //实时预览
    realTime(data) {
      // 预览框高度css要改的话 previewsStyle里面的zoom的固定值100也要跟着变
      this.previewsStyle = {
      width: data.w + "px",
        height: data.h + "px",
        // width:"200px",
        // height:"200px",
        overflow: "hidden",
        margin: "0",
        // zoom: 100 / data.h
        zoom: 150 / data.h
      }
      this.previews = data
    }
  }

}
</script>
<style scoped>
.el-dialog__header .el-dialog__headerbtn .el-icon-close:before{
  content:none;
}
.preview_img {
  margin: 20px 0 0;
}

.preview {
  width: 150px;
  height: 150px;
  overflow: hidden;
}

.imgSize {
  width: 150px;
  height: 150px;
}

.preview {
  width: 100px;
  height: 100px;
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  background: #333;
}

.cropper {
  width: 300px;
  height: 300px;
}

.line {
  margin: 0 0 0 20px;
  border: 0.5px solid #e0e0e0;
}

.preview-box {
  width: 300px;
  height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.uploadHeadBox.el-dialog{
  width: 660px;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/uploaddialog.vue